<div class="modal-header"><h2 class="modal-title">Part Options</h2></div>
<div class="modal-body">
        <div class="mt-1 m-1" *ngIf="options">
            <dx-data-grid #optionsGrid height="300" [dataSource]="options" keyExpr="id" (onToolbarPreparing)="onToolbarPreparing($event)">
                <dxi-column dataField="quantity" caption="Qty" width="50" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="orderLine.part.partNumber" caption="Part #" width="200" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="orderLine.description" caption="Description" [allowEditing]="true"></dxi-column>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button type="button" class="btn btn-sm btn-success me-1" (click)="addMultiple()">Add</button>
                    <button type="button" class="btn btn-sm btn-danger me-1" (click)="delete()" [disabled]="optionsGrid.instance.getSelectedRowsData().length !== 1"  >Delete</button>
                </div>
                <!-- <dxo-editing [mode]="'cell'" [allowUpdating]="true"></dxo-editing> -->
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="order-option-grid"></dxo-state-storing>
            </dx-data-grid>
        </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
